export const permissions = {
  HidePrices: 'HidePrices', //FE
  SkipPayment: 'SkipPayment', //BE -- OrderService / StateTransitionManager
  BlackAndWhite: 'BlackAndWhite', //BE -- UploadService / FileUploadService
  LargeLetter: 'LargeLetter',
  PZU: 'PZU', //BE -- UploadService / FileUploadService //PostZustellUrkunde
  PaymentSlip: 'PaymentSlip', //BE -- UploadService / FileUploadService
  SkipInvoiceEmail: 'SkipInvoiceEmail', //BE -- OrderService / StateTransitionManager
  SkipPdfValidationEmail: 'SkipPdfValidationEmail', //BE -- SplitAndValidationService
  NoInvoiceDownload: 'NoInvoiceDownload', //FE,
  CreditAccount: 'CreditAccount', //BE
  Invite: 'Invite',
  Input: 'Input',
  Output: 'Output',
  International: 'International',
  Backoffice: 'Backoffice',
  FontValidationOverride: 'FontValidationOverride',
  OrderAutocomplete: 'OrderAutocomplete',
  OneProcess: 'OneProcess',
  CostCenter: 'CostCenter',
  MergeLetters: 'MergeLetters',
  FoldType: 'FoldType',
  SelfPayer: 'SelfPayer',
  Briefbutler: 'Briefbutler',
  FrankingOnEnvelope: 'FrankingOnEnvelope',
  WhiteLabeling: 'WhiteLabeling'
}
